
/* injects from baggage-loader */

import StageCardModule from './stage-card/stage-card.module';
import StageBookModule from './stage-book/stage-book.module';
import StageBookQuizModule from './stage-book-quiz/stage-book-quiz.module';
import StageBookPuzzleModule from './stage-book-puzzle/stage-book-puzzle.module';
import StageGeoFormModule from './stage-geoform/stage-geoform.module';
import StagePuzleFormModule from './stage-puzzleform/stage-puzzleform.module';
import StudentAvatarModule from './student-avatar/student-avatar.module';
import SpeedDialModule from './speed-dial/speed-dial.module';
import PuzzleModule from './puzzle/puzzle.module';

const shared = angular.module('ui-module', [
    SpeedDialModule.name,
    StageCardModule.name,
    StageBookModule.name,
    StageBookQuizModule.name,
    StageBookPuzzleModule.name,
    StageGeoFormModule.name,
    StagePuzleFormModule.name,
    StudentAvatarModule.name,
    PuzzleModule.name
]);

export default shared;


// WEBPACK FOOTER //
// ./src/app/components/ui/index.js